//Docs https://support.maestrooo.com/article/304-technical-javascript-events-exposed-by-the-theme
/*document.addEventListener('variant:add', function(event) {
  let items = event.detail.items; // Get items added
  for (let i = 0; i < items.length; i++) {
    const variant = items[i];
    if (variant.id === 47205622612265){
      let formData = {
       'items': [{
        'id': 47213802619177,
        'quantity': 1
        }]
      };
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }
  }
});*/
function getVariantFinalPriceCents(variant) {
  if (!variant) return 0;
  const discountCents = (parseInt(variant.discount_price, 10) || 0) * 100;
  return variant.price - discountCents;
}

function formatShopMoney(cents) {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
}

let shopPayFinalPriceCents = null;
let shopPayVariantId = null;

function patchShopPayMeta(el, variantId, priceCents) {
  const metaAttr = el.getAttribute('shopify-meta');
  if (!metaAttr || !variantId || !priceCents) return;

  try {
    const meta = JSON.parse(metaAttr);
    const variant = meta.variants?.find((v) => String(v.id) === String(variantId));
    if (!variant) return;

    const formatted = formatShopMoney(priceCents);
    if (variant.full_price === formatted) return;

    variant.full_price = formatted;
    variant.price_per_term = formatShopMoney(priceCents / 2);
    el.setAttribute('shopify-meta', JSON.stringify(meta));
  } catch (e) {}
}

function syncShopPayPaymentTerms({ variant, priceCents } = {}) {
  const variantId = variant?.id ?? shopPayVariantId;
  const amount = priceCents ?? (variant ? getVariantFinalPriceCents(variant) : shopPayFinalPriceCents);
  if (!amount || !variantId) return;

  shopPayFinalPriceCents = amount;
  shopPayVariantId = variantId;

  document.querySelectorAll('shopify-payment-terms').forEach((el) => {
    if (variant?.id) el.setAttribute('variant-id', variant.id);
    patchShopPayMeta(el, variantId, amount);
  });
}

function initShopPayMetaObserver() {
  if (window._shopPayMetaObserver) return;

  window._shopPayMetaObserver = new MutationObserver((mutations) => {
    if (!shopPayFinalPriceCents || !shopPayVariantId) return;
    mutations.forEach((m) => {
      if (m.type === 'attributes' && m.attributeName === 'shopify-meta') {
        patchShopPayMeta(m.target, shopPayVariantId, shopPayFinalPriceCents);
      }
    });
  });

  const observeEl = (el) => {
    window._shopPayMetaObserver.observe(el, { attributes: true, attributeFilter: ['shopify-meta'] });
    if (shopPayFinalPriceCents && shopPayVariantId) {
      patchShopPayMeta(el, shopPayVariantId, shopPayFinalPriceCents);
    }
  };

  document.querySelectorAll('shopify-payment-terms').forEach(observeEl);

  new MutationObserver((mutations) => {
    mutations.forEach((m) => {
      m.addedNodes.forEach((node) => {
        if (node.nodeName === 'SHOPIFY-PAYMENT-TERMS') observeEl(node);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
}

document.addEventListener('variant:change', function(event) {
  const variant = event.detail.variant;
  const amount = getVariantFinalPriceCents(variant);
  document.querySelectorAll('.affirm-as-low-as').forEach((el) => el.setAttribute('data-amount', amount));
  if (window.affirm?.ui) affirm.ui.refresh();
  syncShopPayPaymentTerms({ variant, priceCents: amount });
});

document.addEventListener('productTotalPrice:change', function(event) {
  if (event.detail?.price) {
    syncShopPayPaymentTerms({ priceCents: event.detail.price });
  }
});

document.addEventListener('DOMContentLoaded', function() {
  initShopPayMetaObserver();
  const affirmEl = document.querySelector('.affirm-as-low-as[data-amount]');
  const shopPayEl = document.querySelector('shopify-payment-terms');
  if (!affirmEl || !shopPayEl) return;

  const amount = parseInt(affirmEl.getAttribute('data-amount'), 10);
  const variantId = shopPayEl.getAttribute('variant-id');
  if (amount && variantId) {
    shopPayVariantId = variantId;
    syncShopPayPaymentTerms({ priceCents: amount });
  }
});

function gidToNumericId(gid) {
  if (!gid) return null;
  const match = String(gid).match(/(\d+)$/);
  return match ? match[1] : null;
}

function loadActiveGiftRules() {
  const el = document.getElementById('gift-rules-data');
  if (!el) return [];

  try {
    let rules = JSON.parse(el.textContent || '[]');
    if (typeof rules === 'string') rules = JSON.parse(rules);
    if (!Array.isArray(rules)) return [];

    const now = new Date();
    return rules.filter((rule) => {
      if (!rule.giftVariantId || !rule.triggerVariantIds?.length) return false;
      if (rule.startDate && new Date(rule.startDate) > now) return false;
      if (rule.endDate && new Date(rule.endDate) < now) return false;
      return true;
    });
  } catch (error) {
    console.error('[Gift] Failed to parse gift-rules-data', error);
    return [];
  }
}

function getGiftRulesForVariant(variantId) {
  if (!variantId) return [];
  const gid = `gid://shopify/ProductVariant/${variantId}`;
  return loadActiveGiftRules().filter((rule) => rule.triggerVariantIds.includes(gid));
}

async function fetchGiftVariantInfo(variantId) {
  const root = window.Shopify?.routes?.root || '/';
  try {
    const res = await fetch(`${root}variants/${variantId}.js`);
    if (!res.ok) return null;
    return await res.json();
  } catch {
    return null;
  }
}

function escapeGiftHtml(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function formatGiftPrice(cents) {
  if (typeof formatMoney === 'function') return formatMoney(cents);
  return '$' + (Number(cents) / 100).toFixed(2);
}

function getGiftVariantImageSrc(giftVariant) {
  return (
    giftVariant?.featured_image?.src ||
    giftVariant?.featured_media?.preview_image?.src ||
    ''
  );
}

function updateGiftMediaBadge(variantId, hasGift) {
  const media = document.querySelector(
    `.price_img_media[data-variant-id="${variantId}"]`
  );
  const badge = media?.querySelector('.price_img_media__gift-badge');
  if (!badge) return;

  badge.hidden = !hasGift;
}

function clearGiftMediaBadge(variantId) {
  updateGiftMediaBadge(variantId, false);
}

function buildGiftCardHtml(giftVariant, options = {}) {
  const imageSrc = getGiftVariantImageSrc(giftVariant);
  // 与 lumos-flex-2609 / Gift Manager 同源：variants.js 的 title / price
  const name = giftVariant.public_title || giftVariant.title || giftVariant.name || '';
  const originalPrice =
    giftVariant.compare_at_price > 0 ? giftVariant.compare_at_price : giftVariant.price;
  const priceText = originalPrice ? formatGiftPrice(originalPrice) : '';

  // product-marketing / Figma：标题 + 品名 / ($Value)，无紫色 badge
  if (options.layout === 'marketing') {
    const title = (options.title || 'Free Gift').trim() || 'Free Gift';
    const descParts = [
      name ? `<span class="product-gift-card__name-text">${escapeGiftHtml(name)}</span>` : '',
      priceText
        ? `<span class="product-gift-card__value">(${escapeGiftHtml(priceText)} Value)</span>`
        : '',
    ].filter(Boolean);

    return `
      <div class="product-gift-card product-gift-card--marketing">
        <div class="product-gift-card__image${imageSrc ? '' : ' is-empty'}">
          ${
            imageSrc
              ? `<img src="${escapeGiftHtml(imageSrc)}" alt="${escapeGiftHtml(name)}" width="50" height="50" loading="lazy">`
              : ''
          }
        </div>
        <div class="product-gift-card__info">
          <span class="product-gift-card__title">${escapeGiftHtml(title)}</span>
          ${
            descParts.length
              ? `<span class="product-gift-card__desc">${descParts.join('')}</span>`
              : ''
          }
        </div>
      </div>
    `;
  }

  return `
    <div class="product-gift-card">
      <div class="product-gift-card__image${imageSrc ? '' : ' is-empty'}">
        ${
          imageSrc
            ? `<img src="${escapeGiftHtml(imageSrc)}" alt="${escapeGiftHtml(name)}" width="64" height="64" loading="lazy">`
            : ''
        }
      </div>
      <div class="product-gift-card__info">
        <span class="product-gift-card__badge">Free Gift</span>
        <span class="product-gift-card__name">${escapeGiftHtml(name)}</span>
        <span class="product-gift-card__price">${escapeGiftHtml(priceText)}</span>
      </div>
    </div>
  `;
}

function stripGiftLinesFromIncludes(content) {
  const includes = content?.querySelector('.variant-includes');
  if (!includes) return;

  includes.querySelectorAll('li').forEach((li) => {
    const text = li.textContent.toLowerCase();
    if (text.includes('🎁') || /free\s+(gift|pieces)/i.test(text)) {
      li.remove();
    }
  });

  const ul = includes.querySelector('ul');
  if (ul && ul.children.length === 0) {
    includes.hidden = true;
  }
}

function finalizeContentBlock(content) {
  if (!content) return;

  const hasVisibleContent = content.querySelector(
    '.sales_progress, .product-gift-cards--filled, .variant-includes:not([hidden])'
  );
  content.classList.toggle('content--empty', !hasVisibleContent);
}

async function renderProductGiftCards(variantId, container) {
  if (!container) return;

  const matched = getGiftRulesForVariant(variantId);
  if (!matched.length) {
    container.innerHTML = '';
    container.classList.remove('product-gift-cards--filled');
    clearGiftMediaBadge(variantId);
    finalizeContentBlock(container.closest('.content'));
    return;
  }

  const giftIds = [
    ...new Set(matched.map((rule) => gidToNumericId(rule.giftVariantId)).filter(Boolean)),
  ];
  const gifts = await Promise.all(giftIds.map((id) => fetchGiftVariantInfo(id)));
  const validGifts = gifts.filter(Boolean);

  if (!validGifts.length) {
    container.innerHTML = '';
    container.classList.remove('product-gift-cards--filled');
    clearGiftMediaBadge(variantId);
    finalizeContentBlock(container.closest('.content'));
    return;
  }

  container.innerHTML = validGifts
    .map((gift) =>
      buildGiftCardHtml(gift, {
        layout: container.closest('product-marketing, .product-marketing') ? 'marketing' : 'pdp',
        title: container.dataset.giftTitle || '',
      })
    )
    .join('');
  container.classList.add('product-gift-cards--filled');
  updateGiftMediaBadge(variantId, true);

  const content = container.closest('.content');
  stripGiftLinesFromIncludes(content);
  finalizeContentBlock(content);
}

async function initProductGiftCards() {
  if (!document.getElementById('gift-rules-data')) return;

  const containers = document.querySelectorAll('.product-gift-cards[data-variant-id]');
  await Promise.all(
    Array.from(containers).map((el) => renderProductGiftCards(el.dataset.variantId, el))
  );
}

document.addEventListener('DOMContentLoaded', initProductGiftCards);

window.renderProductGiftCards = renderProductGiftCards;

document.addEventListener('click', (event) => {
  if (!document.body.classList.contains('pdp-v2') || window.innerWidth > 768) return;

  const media = event.target.closest('.price_img_media[data-variant-id]');
  if (!media) return;

  const variantId = media.dataset.variantId;
  if (!variantId) return;

  document.dispatchEvent(
    new CustomEvent('package-overview:open', { detail: { variantId: String(variantId) } })
  );
});


// document.addEventListener('DOMContentLoaded', function () {
//   const videos = document.querySelectorAll('video');
//   videos.forEach(function(video) {
//     video.addEventListener('contextmenu', function(e) {
//       e.preventDefault();
//       return false;
//     });
//     video.addEventListener('mousedown', function(e) {
//       if(e.button === 2) {
//         return false
//       }
//     });
//   });
// });




//文字动画效果
const WeScrollAnimatorText = {
  init(selector) {
    if (!selector) {
      return console.error('Selector is required');
    }

    const elements = document.querySelectorAll(selector);
    if (!elements.length) {
      return console.warn('No elements found for selector:', selector);
    }

    elements.forEach(el => this.createObserver(el));

    document.addEventListener('shopify:section:load', (e) => {
      const newElements = Array.from(e.target.querySelectorAll(selector));
      newElements.forEach(el => this.createObserver(el));
    });
  },
  
  /**
   * 为单个元素创建 IntersectionObserver
   * @param {Element} el - 要监听的 DOM 元素
   */
  createObserver(el) {
    let thresholdValue = el.getAttribute('data-threshold');
    console.log(thresholdValue,"thresholdValue");
    
    let threshold = thresholdValue ? parseFloat(thresholdValue) : 0.2;
    if (isNaN(threshold) || threshold < 0 || threshold > 1) {
        console.warn(`Invalid threshold value for element:`, el, `. Using default 0.2.`);
        threshold = 0.2;
    }
    const observer = new IntersectionObserver(this.handleIntersect, {
      root: null, // 视口
      rootMargin: '0px',
      threshold: threshold 
    });
    observer.observe(el);
  },
  handleIntersect(entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }
};


const WeScrollAnimatorList = {
  init(selector, options = {}) {
    const lists = document.querySelectorAll(selector);
    if (!lists.length) return;

    const delayStep = options.delayStep || 200;

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;

        const container = entry.target;
        let items = Array.from(container.querySelectorAll('[role="listitem"]'));

        // 检查容器 flex-direction 是否为 row-reverse
        const style = window.getComputedStyle(container);
        const isRowReverse = style.display.includes('flex') && style.flexDirection === 'row-reverse';

        if (isRowReverse) {
          items = items.reverse();
        }

        items.forEach((item, index) => {
          setTimeout(() => {
            item.classList.add('visible');
          }, index * delayStep);
        });

        observer.unobserve(container);
      });
    }, {
      threshold: 0.2
    });

    // 监听 Section 加载（适用于主题编辑器）
    document.addEventListener('shopify:section:load',  (e) =>  {
      const listAll = e.target.querySelectorAll('.we-animate__list')
      listAll.forEach(list => observer.observe(list))
    });
    lists.forEach(list => observer.observe(list));
  }
};


window.addEventListener('DOMContentLoaded',()=>{
  WeScrollAnimatorText.init('.we-animate__text');
  WeScrollAnimatorList.init('.we-animate__list');
})



// 下拉组件
window.customElements.get("we-select") || window.customElements.define("we-select",class extends HTMLElement{
    constructor() {
        super();
        this._initSelect = this._initSelect.bind(this);
        this._handleInputClick = this._handleInputClick.bind(this);
        this._handleDocumentClick = this._handleDocumentClick.bind(this);
        this._handleScroll = this._handleScroll.bind(this);
        this._globalListenersAdded = false;
    }

    connectedCallback() {
        this.option = JSON.parse(this.getAttribute('option'));
        this.currentValue = this.getAttribute('default-value') || this.option[0].value;
        this.attachShadow({ mode: 'open' });
        this.currentIndex = this.option.findIndex(item => item.value == this.currentValue);
        this.selectId = this.generateSimpleId();
        this._initSelect();
    }

    disconnectedCallback() {
        window.removeEventListener('scroll', this._handleScroll);
        document.removeEventListener('click', this._handleDocumentClick);
        document.removeEventListener('resize', this._handleScroll);
        if (this.optionsWrapper) {
            this.optionsWrapper.remove();
        }
    }
    
    _handleScroll() {
        if (this.optionsWrapper) {
            this.optionsWrapper.classList.remove('active');
        }
    }

    _handleDocumentClick(e) {
        const clickedElement = e.target;
        const isClickInsideComponent = this.contains(clickedElement);
        if (!isClickInsideComponent) {
            if (this.optionsWrapper) {
                this.optionsWrapper.classList.remove('active');
            }
        }
    }

    _initSelect() {
        this.shadowRoot.innerHTML = `
            <style>
              /* 你的组件内部样式 */
            </style>
            <div class="we-select" part="we-select">
                <div class="we-select__input__wrapper" part="we-select__input__wrapper">
                   <div part="we-select__prefix"> 
                      <slot name="prefix"></slot>
                      <div class="we-select__input" part="we-select__input">
                          ${this.option[this.currentIndex].label}
                      </div>
                   </div>
                    <svg part="we-select__arrow" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M5 8.25L12 15.75L19 8.25" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </div>
        `;
        this.selectInput = this.shadowRoot.querySelector('.we-select__input__wrapper');
        this.selectInput.addEventListener('click', this._handleInputClick);
    }
    
    _handleInputClick(e) {
      if (this.optionsWrapper && this.optionsWrapper.classList.contains('active')) {
        this.optionsWrapper.classList.remove('active');
        return;
      }
      
      if (!this.optionsWrapper) {
        const optionsWrapper = document.createElement('div');
        optionsWrapper.classList.add(`we-select-options-${this.selectId}`, 'we-select-options');
        // ...创建下拉框内容...
        optionsWrapper.innerHTML = `
            <div class="we-select__options__wrapper">
              <div class="we-select__options">
                ${
                  this.option.map(item => {
                      if (item.labelText) {
                          return `<div class="we-select__options__item__label">${item.labelText}</div>`;
                      } else {
                          return `<div class="we-select__options__item" value="${item.value}">${item.label}</div>`;
                      }
                  }).join('')
                }
              </div>
            </div>
        `;
        document.body.appendChild(optionsWrapper);
        this.optionsWrapper = optionsWrapper;
        this.optionsWrapper.addEventListener('wheel', this._handleOptionsWheel);
        const selectOptionsItem = this.optionsWrapper.querySelectorAll('.we-select__options__item');
        Array.from(selectOptionsItem).forEach(item => {
            item.addEventListener('click', this._changeSelect.bind(this));
        });

        if (!this._globalListenersAdded) {
          window.addEventListener('scroll', this._handleScroll);
          window.addEventListener('resize', this._handleScroll);
          document.addEventListener('click', this._handleDocumentClick);
          this._globalListenersAdded = true;
        }
      }
     
      // if (this.optionsWrapper.querySelector('.we-select__options__wrapper .we-select__options')) {
      //   this.optionsScrollWrapper.scrollTop = 0;
      // }

      const selectInputPosition = this.getElementViewportPosition(this.selectInput);
      this.optionsWrapper.style.setProperty('--left', `${selectInputPosition.left}px`);
      this.optionsWrapper.style.setProperty('--top', `${selectInputPosition.bottom}px`);
      this.optionsWrapper.style.setProperty('--width', `${selectInputPosition.width}px`);
      this.optionsWrapper.classList.add('active');

      this.optionsWrapper.querySelector('.we-select__options__wrapper').scrollTop = 0;
    }

    _handleOptionsWheel(e) {
      e.stopPropagation();
    }

    /**
     * 获取元素位置
     */
    getElementViewportPosition(element) {
      if (!element) {
        return null;
      }
      const rect = element.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const bottomToViewport = viewportHeight - rect.bottom;
      return {
        left: rect.left,
        bottom: rect.bottom,
        bottomToViewport: bottomToViewport,
        width: rect.width,
        height: rect.height,
      };
    }

    /**
     * 生成唯一ID
     */
    generateSimpleId() {
      return Math.random().toString(36).substring(2, 9) + Date.now().toString(36);
    }

    _changeSelect(e){
      const value = e.target.getAttribute('value')
      if (this.currentValue === value) return
      this.shadowRoot.querySelector('.we-select__input').innerText = this.option.find(item => item.value == value).label
      this.currentValue = value                
      this.dispatchEvent(new CustomEvent('change', {
          detail: {
              value: value
          }
      }))
    }
})

// 自定义affirm显示
window.customElements.get('we-affirm') ||
  window.customElements.define('we-affirm', class extends HTMLElement {
    connectedCallback() {
      const price = parseFloat(this.getAttribute('price')); // price 单位：美分
      if (isNaN(price)) {
        this.innerText = '';
        return;
      }

      const { months, apr } = this.getMaxInstallment(price);
      const monthly = this.calcMonthly(price / 100, months, apr); // 转成美元计算
      this.innerText = `or $${monthly}/mo. for ${months} months`;
    }

    // 最大分期规则（单位：美分）
    getMaxInstallment(price) {
      if (price <= 69999) {
        return { months: 12, apr: 15.00 };
      } else if (price <= 169999) {
        return { months: 18, apr: 14.99 };
      } else {
        return { months: 36, apr: 14.99 };
      }
    }

    // 等额本息公式（向上取整）
    calcMonthly(price, months, apr) {
      if (apr === 0) {
        return Math.ceil(price / months);
      }
      const monthlyRate = apr / 12 / 100;
      const payment = price * (monthlyRate * Math.pow(1 + monthlyRate, months)) /
        (Math.pow(1 + monthlyRate, months) - 1);
      return Math.ceil(payment);
    }
  });

/**
 * Sync GA4 client_id onto the cart as attribute `_ga4_id`
 * so it becomes an order attribute at checkout.
 *
 * Non-blocking: never preventDefault checkout/submit — Shopify needs the native
 * `name="checkout"` submitter to enter checkout.
 */
(function syncGa4IdToCart() {
  const ATTR_KEY = '_ga4_id';
  const STORAGE_KEY = 'wecreat_ga4_client_id';
  const MEASUREMENT_ID = 'G-D10SS0F42E';
  const CART_PERMALINK_RE = /\/cart\/\d+(?::\d+)?(?:,\d+(?::\d+)*)?/;
  let lastSyncedId = null;
  let syncPromise = null;

  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function getCookie(name) {
    const match = document.cookie.match(
      new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)')
    );
    return match ? decodeURIComponent(match[1]) : null;
  }

  function rememberClientId(id) {
    if (!id) return;
    lastSyncedId = id;
    try {
      sessionStorage.setItem(STORAGE_KEY, id);
    } catch (e) {}
  }

  function clientIdFromStorage() {
    try {
      return sessionStorage.getItem(STORAGE_KEY) || null;
    } catch (e) {
      return null;
    }
  }

  function clientIdFromGaCookie() {
    const raw = getCookie('_ga');
    if (!raw) return null;
    const parts = raw.split('.');
    if (parts.length < 4) return null;
    return parts.slice(-2).join('.');
  }

  function clientIdFromGtag() {
    return new Promise((resolve) => {
      if (typeof window.gtag !== 'function') {
        resolve(null);
        return;
      }
      let settled = false;
      const done = (id) => {
        if (settled) return;
        settled = true;
        resolve(id || null);
      };
      try {
        window.gtag('get', MEASUREMENT_ID, 'client_id', done);
      } catch (e) {
        done(null);
        return;
      }
      setTimeout(() => done(null), 1500);
    });
  }

  async function resolveGa4ClientId() {
    const cached = lastSyncedId || clientIdFromStorage() || clientIdFromGaCookie();
    if (cached) {
      rememberClientId(cached);
      return cached;
    }
    const fromGtag = await clientIdFromGtag();
    if (fromGtag) rememberClientId(fromGtag);
    return fromGtag;
  }

  function injectHiddenInputs(clientId) {
    document.querySelectorAll('form[action="/cart"], form[action$="/cart"]').forEach((form) => {
      let input = form.querySelector(`input[name="attributes[${ATTR_KEY}]"]`);
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = `attributes[${ATTR_KEY}]`;
        form.appendChild(input);
      }
      input.value = clientId;
    });
  }

  function stampCartPermalink(url, clientId) {
    if (!url || !clientId) return url;
    try {
      const u = new URL(String(url), window.location.origin);
      if (!CART_PERMALINK_RE.test(u.pathname)) return url;
      u.searchParams.set(`attributes[${ATTR_KEY}]`, clientId);
      return u.pathname + u.search + u.hash;
    } catch (e) {
      return url;
    }
  }

  function stampAnchorHrefs(clientId) {
    if (!clientId) return;
    document.querySelectorAll('a[href*="/cart/"]').forEach((a) => {
      const next = stampCartPermalink(a.getAttribute('href'), clientId);
      if (next && next !== a.getAttribute('href')) a.setAttribute('href', next);
    });
  }

  async function syncToCart(force) {
    const clientId = await resolveGa4ClientId();
    if (!clientId) return null;
    injectHiddenInputs(clientId);
    stampAnchorHrefs(clientId);
    if (!force && clientId === lastSyncedId) return clientId;
    if (syncPromise) return syncPromise;

    syncPromise = fetch(`${cartRoot()}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { [ATTR_KEY]: clientId } }),
      keepalive: true,
      credentials: 'same-origin',
    })
      .then((res) => (res.ok ? res.json() : null))
      .then((cart) => {
        if (!cart) return null;
        rememberClientId((cart.attributes && cart.attributes[ATTR_KEY]) || clientId);
        injectHiddenInputs(clientId);
        stampAnchorHrefs(clientId);
        return lastSyncedId;
      })
      .catch(() => null)
      .finally(() => {
        syncPromise = null;
      });

    return syncPromise;
  }

  function currentClientId() {
    return lastSyncedId || clientIdFromStorage() || clientIdFromGaCookie();
  }

  // Capture phase: stamp Shop Now permalinks, kick sync — never block checkout
  function onPointerCapture(event) {
    const target = event.target;
    if (!target || !target.closest) return;

    const permalink = target.closest('a[href*="/cart/"]');
    if (permalink) {
      try {
        const url = new URL(permalink.href, window.location.origin);
        if (CART_PERMALINK_RE.test(url.pathname)) {
          const stamped = stampCartPermalink(permalink.href, currentClientId());
          if (stamped && stamped !== permalink.getAttribute('href')) {
            permalink.setAttribute('href', stamped);
          }
        }
      } catch (e) {}
      syncToCart(true);
      return;
    }

    const checkoutEl = target.closest(
      'a[href*="/checkout"], button[name="checkout"], input[name="checkout"], [href="/checkout"]'
    );
    if (checkoutEl) syncToCart(true);
  }

  // buy-bar: location.href = `/cart/${id}:${qty}`
  function patchLocationNavigation() {
    const proto = window.Location && window.Location.prototype;
    if (!proto) return;

    ['assign', 'replace'].forEach((method) => {
      const original = proto[method];
      if (typeof original !== 'function' || original.__ga4Patched) return;
      const patched = function (url) {
        return original.call(this, stampCartPermalink(url, currentClientId()));
      };
      patched.__ga4Patched = true;
      proto[method] = patched;
    });

    try {
      const desc = Object.getOwnPropertyDescriptor(proto, 'href');
      if (!desc || !desc.set || desc.set.__ga4Patched) return;
      const nativeSet = desc.set;
      const nativeGet = desc.get;
      const patchedSet = function (url) {
        return nativeSet.call(this, stampCartPermalink(url, currentClientId()));
      };
      patchedSet.__ga4Patched = true;
      Object.defineProperty(proto, 'href', {
        configurable: true,
        enumerable: desc.enumerable,
        get: nativeGet,
        set: patchedSet,
      });
    } catch (e) {}
  }

  function boot() {
    const warm = clientIdFromStorage() || clientIdFromGaCookie();
    if (warm) {
      rememberClientId(warm);
      injectHiddenInputs(warm);
      stampAnchorHrefs(warm);
    }
    syncToCart(false);
    setTimeout(() => syncToCart(false), 2000);
    setTimeout(() => syncToCart(false), 5000);
  }

  patchLocationNavigation();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('cart:change', () => syncToCart(false));
  document.addEventListener('variant:add', () => syncToCart(false));
  document.addEventListener('click', onPointerCapture, true);
  window.addEventListener('pageshow', () => syncToCart(false));
})();
